import style from './style';

export type TenantNameProps = {
  tenantName: string;
};

const TenantName = ({ tenantName: name }: TenantNameProps) => {
  return (
    <div className={style.TenantNameWrapper}>
      <div className={style.TenantName}>
        <span className="overflow-hidden overflow-ellipsis whitespace-nowrap">
          {name}
        </span>
      </div>
    </div>
  );
};

export default TenantName;
